import {
  Result,
  RESULT_VARIANT_SUCCESS,
} from '@sgcmpteltd/uikit-react/components/result';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const SuccessStep: Component = ({
  className,
}) => (
  <div
    className={cx(
      styles.containerRoot,
      className,
    )}>
    <div
      className={styles.containerResult}>
      <Result
        message={(
          <div className={styles.textMessage}>
            {/* eslint-disable-next-line @stylistic/max-len */}
            <span>Email Enquiry has been sent successfully. Your request will be attended shortly.</span>
          </div>
        )}
        title="Saved Successfully!"
        variant={RESULT_VARIANT_SUCCESS} />
    </div>
  </div>
);
